import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { calculateRanges } from './helpers';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Page from './_partials/Page';
import Dots from './_partials/Dots';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './Pagination.scss';
var Pagination = function (_a) {
    var currentPage = _a.currentPage, totalPages = _a.totalPages, pageSize = _a.pageSize, _b = _a.showPageNumbers, showPageNumbers = _b === void 0 ? true : _b, onChangePage = _a.onChangePage, getPageUrl = _a.getPageUrl;
    var t = useTranslation().t;
    if (totalPages < 2) {
        return null;
    }
    var _c = calculateRanges(currentPage, totalPages), startingBlock = _c.startingBlock, showStartDots = _c.showStartDots, midBlock = _c.midBlock, showEndDots = _c.showEndDots, endBlock = _c.endBlock;
    var renderButton = function (n) { return (React.createElement(Page, { key: n, page: n, isCurrent: n === currentPage, getPageUrl: getPageUrl, onChangePage: onChangePage, biData: {
            evid: BiEventType.PAGE_NAVIGATION_CLICK,
            direction: n,
            thumbs_per_page: pageSize,
        } }, n)); };
    return (React.createElement("div", { className: s['root'] },
        currentPage > 1 && (React.createElement(Page, { page: currentPage - 1, isCurrent: false, onChangePage: onChangePage, getPageUrl: getPageUrl, biData: {
                evid: BiEventType.PAGE_NAVIGATION_CLICK,
                direction: 'previous',
                thumbs_per_page: pageSize,
            } },
            React.createElement(ArrowLeft, { size: IconSize.MEDIUM, disableDefaultColors: true, className: classnames(s['arrow'], s['prev']) }),
            t('pagination.prev'))),
        showPageNumbers && (React.createElement(React.Fragment, null,
            startingBlock.map(renderButton),
            showStartDots && (React.createElement(Dots, { pageSize: pageSize, totalPages: totalPages, onChangePage: onChangePage, getPageUrl: getPageUrl })),
            midBlock.map(renderButton),
            showEndDots && (React.createElement(Dots, { pageSize: pageSize, totalPages: totalPages, onChangePage: onChangePage, getPageUrl: getPageUrl })),
            endBlock.map(renderButton))),
        currentPage < totalPages && (React.createElement(Page, { page: currentPage + 1, isCurrent: false, onChangePage: onChangePage, getPageUrl: getPageUrl, biData: {
                evid: BiEventType.PAGE_NAVIGATION_CLICK,
                direction: 'next',
                thumbs_per_page: pageSize,
            } },
            t('pagination.next'),
            React.createElement(ArrowRight, { size: IconSize.MEDIUM, disableDefaultColors: true, className: classnames(s['arrow'], s['next']) })))));
};
Pagination.displayName = 'Pagination';
export default Pagination;
//# sourceMappingURL=Pagination.js.map